import React, {Component} from 'react'
import FJToolbarIconButton from './FJToolbarIconButton'
import FJDropDown from "fj-components/FJDropDown"
import InlineSVG from "react-inlinesvg";
import FJFormatLeftIcon from '../../../icon/FJFormatLeftIcon.svg';
import FJFormatCenterIcon from '../../../icon/FJFormatCenterIcon.svg';
import FJFormatRightIcon from '../../../icon/FJFormatRightIcon.svg';

import './FJAlign.less'
import FJLocalStore from "../../../store/FJLocalStore";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJUtil from "../../../util/FJUtil";

class FJAlign extends Component {

  _listComponent = (alignment) => {
    let list = [
      {
        tooltip: FJLocalStore._('align-left'),
        className: 'u-tooltip-bottom c-button-hover',
        active: alignment === "left",
        icon: <InlineSVG src={FJFormatLeftIcon} element='div'/>,
        dataChange: () => {
          this.props.alignmentChanged("left");
        },
      },
      {
        tooltip: FJLocalStore._('align-center'),
        className: 'u-tooltip-bottom c-button-hover',
        active: alignment === "center",
        icon: <InlineSVG src={FJFormatCenterIcon} element='div'/>,
        dataChange: () => {
          this.props.alignmentChanged("center");
        },
      },
      {
        tooltip: FJLocalStore._('align-right'),
        className: 'u-tooltip-bottom c-button-hover',
        active: alignment === "right",
        icon: <InlineSVG src={FJFormatRightIcon} element='div'/>,
        dataChange: () => {
          this.props.alignmentChanged("right");
        },
      }
    ];
    return list.map((item, index) => {
      return <FJToolbarIconButton tooltip={item.tooltip}
                                  key={index}
                                  className={item.className}
                                  active={item.active}
                                  onClick={item.dataChange}
                                  icon={item.icon}
      />;
    });
  };

  _toggleTooltip = (ele, bool) => {
    FJUtil.toggleTooltip(ele, bool);
  };

  render() {
    let {alignment, disabled} = this.props;
    let icon;
    switch (alignment) {
      case 'left':
        icon = <InlineSVG src={FJFormatLeftIcon} element='div'/>;
        break;
      case 'center':
        icon = <InlineSVG src={FJFormatCenterIcon} element='div'/>;
        break;
      case 'right':
        icon = <InlineSVG src={FJFormatRightIcon} element='div'/>;
        break;
      default:
        icon = <InlineSVG src={FJFormatCenterIcon} element='div'/>;
    }
    return (
      <FJDropDown overlay={
        <div className='c-align-popup-panel'>
          {this._listComponent(alignment)}
        </div>
      }
                  canTriggerActive
                  triggerClick={() => {FJCoreUtil.triggerBodyMousedown()}}
                  disabled={disabled}
                  toggleTooltip={this._toggleTooltip}
                  overlayClassName='c-overlay-bg'
                  hasArrow={true}
      >
        <FJToolbarIconButton disabled={disabled}
                             className='u-tooltip-bottom c-toolbar-icon-btn'
                             tooltip={FJLocalStore._('align')}
                             style={{float: 'left', marginLeft: '6px'}}
                             icon={icon}/>
      </FJDropDown>
    );
  }
}

export default FJAlign;
